import AppCommonModal from "@/components/AppCommonModal";
import Image from "next/image";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Dropdown, Form, Input, message, Select, Space, Image as AntdImage } from 'antd';
import { APIGetLinkByPid, APIRefreshCapStatus, APIRequestSampleCreate } from "@/api";
import CommonLoading from "@/components/CommonLoading";
import { countryPhoneCodes } from "@/constants/Phone";
import { DownOutlined, LoadingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import UnLockHighestCommissionModal from "@/components/UnLockHighestCommissionModal";
import { getProductImage } from "@/utils/utils";
import styles from "@/components-mobile/FreeSamplePopup/index.module.scss";
import AddShowCaseStepModal from "@/components/ProductModal";
import gaTracker from "@/ga";
import { useRouter } from "next/router";
import useLogin from "@/hooks/useLogin";
import useLanguage from "@/hooks/useLanguage";
import { Trans } from 'react-i18next';

export const GetFreeSampleModal = ({ show, onCancel, imgUrl, title, productItem }) => {
  const {t, freeSampleIcon} = useLanguage();
  const [step, setStep] = useState(1);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [tkLoading, setTKLoading] = useState(false);
  const [isObtain, setIsObtain] = useState(false);
  const [showCase, setShowCase] = useState(false);
  const [productLink, setProductLink] = useState("");
  const userInfo = useSelector(state => state.home.userInfo.userInfo);
  const router = useRouter();
  const { getUserInfo } = useLogin();

  const addTk = (e) => {
    e.stopPropagation();
    if (router.pathname === "/") {
      gaTracker.trackEvent("home_add_showcase", true);
    }
    if (router.pathname === "/product/[id]") {
      gaTracker.trackEvent("details_rec", true);
    }
    if (loading) return;
    if (productItem.needApplyLink) {
      setTKLoading(true);
      APIGetLinkByPid(productItem.productId).then(resp => {
        if (resp?.data.url) {
          const url = resp.data.url;
          setProductLink(url);
          setShowCase(true);
        } else {
          message.info(t('free_sample.product_taken_down'));
        }
      }).finally(() => {
        setTKLoading(false);
      });
    } else {
      const url = productItem.url;
      setProductLink(url);
      setShowCase(true);
    }
  };

  const refreshCap = async () => {
    const res = await APIRefreshCapStatus({});
    getUserInfo();
  };

  const step1 = useMemo(() => {
    return <div className={""}>
      <div className={"bg-color1 flex items-center gap-3 mt-[22px] px-3 py-2 rounded-[8px] text-[14px] leading-1.5"}>
        <img src={imgUrl} className={"w-20 h-20 rounded-[8px] shrink-0 object-cover"} />
        <div className={"text-color5 text-[14px] font-300"}>
          {title}
        </div>
      </div>

      <div className={"mt-[20px]"}>
        <div className={"text-color5 font-bold text-[16px]"}>{t('free_sample.process')}</div>
        <div className={"mt-[20px] mb-[15px] "}>
          <ol>
            <li className={"infoText"}>
              <Trans i18nKey='free_sample.add_to_showcase_step1'>
                1. Click <span onClick={addTk} className={"infoTextDiff underline cursor-pointer"}>Add to Showcase {tkLoading && <LoadingOutlined></LoadingOutlined>}</span> to add the product to your showcase
              </Trans>
            </li>
            <li className={"infoText"}>
              <Trans i18nKey='free_sample.check_tiktok_step2'>
                2. Check the TikTok Product Card Info to see if there is a <span className={"infoTextDiff"}>Get Free Sample</span> button
              </Trans>
            </li>
            <li className={"infoText"}>
              <Trans i18nKey='free_sample.follow_process_step3'>
                3. If you see the Get Free Sample button on TikTok, <span className={"infoTextDiff"}>follow the process below</span> to request a sample
              </Trans>
            </li>
          </ol>
        </div>
        <div className={"rounded-[20px] overflow-hidden"}>
          <AntdImage className={"object-cover"} src={freeSampleIcon} alt={""}></AntdImage>
        </div>
      </div>
    </div>;
  }, [isObtain, userInfo, tkLoading]);

  const [freeSampleModal, setFreeSampleModal] = useState(false);

  const submit = async (values) => {
    // todo 需要补充申样逻辑
    console.log(values, "values");
    if (loading) return;
    gaTracker.trackEvent("offline_sam_submit");
    setLoading(true);
    try {
      const res = await APIRequestSampleCreate(JSON.stringify({
        ...values,
        productId: productItem?.productId,
        phoneNum: `+${values.phonePrefix} ` + values.phoneNum
      }));
      if (res.data.result) {
        setStep(4);
      } else {
        message.info(t('free_sample.submission_failed'));
      }
    } catch (e) {
      console.log(e, "eerroor");
      message.info(t('free_sample.application_failed'));
    }
    setLoading(false);
  };

  const prefixSelector = useMemo(() => (
    <Form.Item initialValue={"1"} name={"phonePrefix"} noStyle>
      <Select
        style={{
          width: 100,
        }}
        getPopupContainer={(triggerNode) => triggerNode.parentNode} // 解决被遮挡问题
      >
        {
          countryPhoneCodes.map((item, index) => {
            return <Select.Option key={index} value={item.value}>+ {item.value}</Select.Option>;
          })
        }
      </Select>
      {/* <Dropdown*/}
      {/*  menu={{*/}
      {/*    items:countryPhoneCodes,*/}
      {/*  }}*/}
      {/* >*/}
      {/*  <a onClick={(e) => e.preventDefault()}>*/}
      {/*    <Space>*/}
      {/*      Hover me*/}
      {/*      <DownOutlined />*/}
      {/*    </Space>*/}
      {/*  </a>*/}
      {/* </Dropdown>*/}
    </Form.Item>
  ), []);

  useEffect(() => {
    setIsObtain(userInfo?.obtain);
  }, [userInfo]);


  const step2 = useMemo(() => {
    return <div className={""}>
      <div className={"bg-color1 flex items-center gap-3 mt-[22px] px-3 py-2 rounded-[8px] text-[14px] leading-1.5"}>
        <img src={imgUrl} className={"w-20 h-20 rounded-[8px] shrink-0 object-cover"} />
        <div className={"text-color5 text-[14px] font-300"}>
          {title}
        </div>
      </div>
      <div className={"mt-[20px]"}>
        <div className={"text-color5 font-bold text-[16px]"}>{t('free_sample.fill_info')}</div>
        <div className={"mt-3"}>
          <Form
            name={"Free Sample Info"}
            onFinish={submit}
            autoComplete={"off"}
            layout={"vertical"}
          >
            <div className={"flex items-center gap-4"}>
              <Form.Item
                label={t('free_sample.address')}
                name={"address"}
                className={"flex-1"}
                rules={[
                  {
                    required: true,
                    message: t('free_sample.validation.address'),
                  },
                ]}
              >
                <Input maxLength={500} placeholder={t('free_sample.address_placeholder')} />
              </Form.Item>
              <Form.Item
                label={t('free_sample.zip_code')}
                name={"zipCode"}
                className={"flex-1"}
                rules={[
                  {
                    required: true,
                    message: t('free_sample.validation.zip_code'),
                  },
                ]}
              >
                <Input maxLength={20} placeholder={t('free_sample.zip_code_placeholder')} />
              </Form.Item>
            </div>
            <div className={"flex items-center gap-4"}>
              <Form.Item
                label={t('free_sample.email')}
                name={"email"}
                className={"flex-1"}
                rules={[
                  {
                    type: 'email',
                    message: t('free_sample.validation.email'),
                  },
                  {
                    required: true,
                    message: t('free_sample.validation.email_required'),
                  },
                ]}
              >
                <Input maxLength={300} placeholder={t('free_sample.email_placeholder')} />
              </Form.Item>
              <Form.Item
                label={t('free_sample.name')}
                name={"name"}
                className={"flex-1"}
                rules={[
                  {
                    required: true,
                    message: t('free_sample.validation.name'),
                  },
                ]}
              >
                <Input maxLength={50} placeholder={t('free_sample.name_placeholder')} />
              </Form.Item>
            </div>
            <div className={"flex items-center gap-4"}>
              <Form.Item
                form={form}
                label={t('free_sample.phone')}
                name={"phoneNum"}
                className={"flex-1"}
                rules={[
                  {
                    required: true,
                    message: t('free_sample.validation.phone'),
                  },
                  {
                    pattern: /^(\+\d{1,3}( )?)?((\$\d{1,4}\$)|\d{1,4})[- .]?\d{1,4}[- .]?\d{1,9}$/,
                    message: t('free_sample.validation.phone_format')
                  }
                ]}
              >
                <Input maxLength={20} addonBefore={prefixSelector} placeholder={t('free_sample.phone_placeholder')} />
              </Form.Item>
              <div className={"flex-1"}>

              </div>
            </div>
            <div className={"flex items-center gap-4"}>
              <Form.Item
                label={t('free_sample.product_note')}
                name={"productNote"}
                className={"flex-1"}
              >
                <Input.TextArea showCount maxLength={500} placeholder={t('free_sample.product_note_placeholder')} />
              </Form.Item>
            </div>
            <Form.Item>
              <div className={"flex items-center justify-center gap-6"}>
                <Button loading={loading} htmlType={"submit"} className={"cursor-pointer trans-all hover:opacity-80 !bg-linear !text-white text-[14px] rounded-[25px] font-bold w-[220px] h-[44px] flex items-center justify-center"}>
                  {
                    loading && <CommonLoading className={"w-3 h-3"}></CommonLoading>
                  }
                  {t('free_sample.submit')}
                </Button>
                <Button htmlType={"reset"} className={"cursor-pointer trans-all hover:opacity-80 !bg-[#EDF0FE] !text-color2 text-[14px] rounded-[25px] font-bold w-[220px] !border-none h-[44px] flex items-center justify-center"}>{t('free_sample.clear_all')}</Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>;
  }, []);

  const step3Fail = useMemo(() => {
    return <div className={"flex flex-col items-center justify-center py-10"}>
      <Image className={"w-[72px] h-[72px]"} width={72} height={72} src={"/images/warning-tips-icon.svg"} alt={""}></Image>
      <div className={"text-[14px] leading-1.5 text-color5 w-[465px] text-center py-[30px]"}>
        <Trans i18nKey='free_sample.join_program_text'>
          Join our <span className={"text-primary font-bold"}>Creator Affiliate Program</span> to enjoy the highest commission rate rate, click the <span onClick={() => setFreeSampleModal(true)} className={"text-primary font-bold cursor-pointer"}>Obtain Eligibility</span> button to join us!
        </Trans>
      </div>
    </div>;
  }, []);

  const step5Success = useMemo(() => {
    return <div className={"flex flex-col items-center justify-center py-10"}>
      <Image className={"w-[72px] h-[72px]"} width={72} height={72} src={"/images/success-tips-icon.svg"} alt={""}></Image>
      <div className={"text-[14px] leading-1.5 text-color5 w-[465px] text-center py-[30px]"}>
        <Trans i18nKey='free_sample.linking_invite'>
          we'll send you a Linking Invite and more partner details from our affiliate account <span className={"text-primary font-bold"}> Uango </span> to your TikTok. Simply check the link we sent and <span className={"text-primary font-bold"}>accept the request!</span>
        </Trans>
      </div>
    </div>;
  }, []);

  const step4Success = useMemo(() => {
    return <div className={"flex flex-col items-center justify-center py-10"}>
      <Image className={"w-[72px] h-[72px]"} width={72} height={72} src={"/images/success-tips-icon.svg"} alt={""}></Image>
      <div className={"text-[16px] leading-1.5 text-color5  text-center py-[30px]"}>
        <Trans i18nKey='free_sample.approval_notice_text'>
          If your sample request is approved and sent out by the merchant, we will notify you within a week via email /anyStarr US/ Befriends SSG US/ Uango and shop account tagged with anyStarr. We'll also include the courier number where the sample was sent, so you can check it out at any time!
        </Trans>
      </div>
      <Image className={"w-[471px] h-[160px]"} width={471} height={160} src={"/images/freeSample-success-icon.svg"} alt={""}></Image>
    </div>;
  }, []);

  const renderModalWidth = useMemo(() => {
    if ([3, 4].includes(step)) return 561;
    return 793;
  }, [step]);


  const renderTitle = useMemo(() => {
    if (step === 1) return t('free_sample.get_sample');
    if (step === 2) return t('free_sample.request_offline');
    return "";
  }, [step]);

  const render = useMemo(() => {
    if (step === 1) {
      return step1;
    }
    if (step === 2) {
      return step2;
    }
    if (step === 3) { // fail
      return step3Fail;
    }
    if (step === 4) { // success
      return step4Success;
    }
  }, [step]);

  return <>
    {
      !freeSampleModal && <AppCommonModal className={"zoom_1920"} width={renderModalWidth} show={show} onCancel={onCancel} title={renderTitle}>
        {
          render
        }
      </AppCommonModal>
    }
    {
      freeSampleModal && <UnLockHighestCommissionModal utmObtain={"sam_obtain"} onSuccess={() => {
        setFreeSampleModal(false);
        setStep(2);
      }} type={2} title={productItem.title} imgUrl={getProductImage(productItem)} show={freeSampleModal} onCancel={onCancel}></UnLockHighestCommissionModal>
    }
    {
      showCase && <AddShowCaseStepModal productIds={productItem.productId} visible={showCase} link={productLink} onCancel={() => setShowCase(false)} />
    }
  </>;
};
